import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import omit from 'lodash/omit';
import { Utils } from '@react-awesome-query-builder/ui';
const { useOnPropsChanged } = Utils.ReactUtils;
const { mapListValues } = Utils.ListUtils;
const Option = Select.Option;

export const SELECT_WIDTH_OFFSET_RIGHT = 48;
const DEFAULT_FONT_SIZE = '14px';
const DEFAULT_FONT_FAMILY = "'Helvetica Neue', Helvetica, Arial, sans-serif";

export const BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ['tr', 'br'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ['br', 'tr'],
    offset: [0, -4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  }
};

export const calcTextWidth = function (
  str,
  fontFamily = DEFAULT_FONT_FAMILY,
  fontSize = DEFAULT_FONT_SIZE
) {
  if (typeof document !== 'undefined') {
    var div = document.createElement('div');
    div.innerHTML = str;
    var css = {
      position: 'absolute',
      float: 'left',
      'white-space': 'nowrap',
      visibility: 'hidden',
      'font-size': fontSize,
      'font-family': fontFamily
    };
    Object.keys(css).forEach((k) => {
      div.style[k] = css[k];
    });
    div = document.body.appendChild(div);
    var w = div.offsetWidth;
    document.body.removeChild(div);
    return w;
  } else {
    return undefined;
  }
};

export default class CustomMultiSelect extends Component {
  static propTypes = {
    setValue: PropTypes.func.isRequired,
    config: PropTypes.object.isRequired,
    value: PropTypes.array,
    field: PropTypes.any,
    placeholder: PropTypes.string,
    customProps: PropTypes.object,
    fieldDefinition: PropTypes.object,
    readonly: PropTypes.bool,
    // from fieldSettings:
    customListValues: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    allowCustomValues: PropTypes.bool
  };

  constructor(props) {
    super(props);
    useOnPropsChanged(this);
    this.onPropsChanged(props);
  }

  onPropsChanged(nextProps) {
    const { customListValues } = nextProps;

    let optionsMaxWidth = 0;
    mapListValues(customListValues, ({ title, value }) => {
      optionsMaxWidth = Math.max(optionsMaxWidth, calcTextWidth(title, null));
    });
    if (!Number.isNaN(optionsMaxWidth) && optionsMaxWidth) {
      this.optionsMaxWidth = optionsMaxWidth;
    }

    this.options = mapListValues(customListValues, ({ title, value }) => {
      return (
        <Option key={value} value={value}>
          {title}
        </Option>
      );
    });
  }

  handleChange = (val) => {
    if (val && !val.length) val = undefined; //not allow []
    this.props.setValue(val);
  };

  filterOption = (input, option) => {
    const dataForFilter = option.children || option.value;
    return dataForFilter.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  render() {
    const {
      config,
      placeholder,
      allowCustomValues,
      customProps,
      value,
      readonly
    } = this.props;
    const { renderSize } = config.settings;
    const placeholderWidth = calcTextWidth(placeholder);
    const dropdownEmptyWidth = placeholderWidth
      ? placeholderWidth + SELECT_WIDTH_OFFSET_RIGHT
      : null;
    const aValue = value && value.length ? value : undefined;
    const width = aValue ? null : dropdownEmptyWidth;
    const dropdownWidth = this.optionsMaxWidth
      ? this.optionsMaxWidth + SELECT_WIDTH_OFFSET_RIGHT
      : null;
    const customSelectProps = omit(customProps, ['showCheckboxes']);

    return (
      <Select
        disabled={readonly}
        showArrow
        mode={allowCustomValues ? 'tags' : 'multiple'}
        style={{
          minWidth: width,
          width: width,
          maxWidth: '600px'
        }}
        dropdownStyle={{
          width: dropdownWidth
        }}
        key={'widget-multiselect'}
        popupMatchSelectWidth={false}
        placeholder={placeholder}
        size={renderSize}
        value={aValue}
        onChange={this.handleChange}
        filterOption={this.filterOption}
        {...customSelectProps}>
        {this.options}
      </Select>
    );
  }
}
